import React from "react";
import { Link } from "react-router-dom";
import { BsChevronRight } from "react-icons/bs";
import styled from "styled-components";

const Section = styled.div`
  height: 100vh;
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  padding: 15px;
  box-sizing: border-box;

  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;

    > div.not_found_content {
      width: 500px;
      @media screen and (max-width: 610px) {
        width: unset;
      }

      h1 {
        text-align: center;
        color: var(--choco);
        font-size: 150px;
        font-family: var(--casanova);
        margin-bottom: 25px;
        @media screen and (max-width: 610px) {
          font-size: 100px;
        }
        @media screen and (max-width: 430px) {
          font-size: 50px;
        }
      }

      p.subheading {
        text-align: center;
        color: var(--darkYellow);
        font-size: 20px !important;
        font-family: $monserrat;
        margin-bottom: 20px;
        text-transform: uppercase;
        font-weight: 700;
      }

      > p {
        font-weight: 400;
        color: var(--darkYellow);
        text-align: center;
        font-weight: 18px;
        margin-bottom: 25px;
      }

      > a {
        padding: 13px 25px;
        border: 1px solid var(--darkYellow);
        color: var(--white);
        background: var(--dark);
        border-radius: 8px;
        text-transform: capitalize;
        display: block;
        width: fit-content;
        margin: 0 auto;
        transition: 0.4s;
        display: flex;
        align-items: center;

        > svg {
          margin-left: 5px;
        }

        &:hover {
          background: var(--yellow);
          color: var(--white);
        }
      }
    }
  }
`;

const PageNotFound = () => {
  return (
    <Section className="page_not_found">
      <div className="conatiner">
        <div className="not_found_content">
          <h1>404</h1>
          <p className="subheading">Page not found</p>

          <p>Webpage not found! Our apologies for the inconvenience</p>
          <Link to="/">
            go to homepage <BsChevronRight />
          </Link>
        </div>
      </div>
    </Section>
  );
};

export default PageNotFound;
